<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'BasicViewer',

  props: {
    pdfData: {
      type: String,
      required: false,
      default: ''
    },
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    }
  },

  methods: {
    onDismissed (target) {
      this.$emit('dismiss', target || true)
    }
  }
})
</script>

<template>
  <div>
    <div v-if="pdfData">
      <object :data="`${pdfData}`" type="application/pdf" :style="{ width, height }"></object>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/Reports/BasicViewer.vue